export default __webpack_public_path__ + "static/media/navbar-img-3.55343791.jpg";